<template>
  <!-- <div
    :href="button.type === 'link' ? button.link : '#'" 
    class="
      flex justify-between items-center w-full font-medium
      py-2
      set-border-b border-gray-100 md:w-auto hover:bg-gray-50
      md:hover:bg-transparent md:border-0 md:p-0 dark:text-gray-400
      dark:hover:bg-gray-700 md:dark:hover:bg-transparent dark:border-gray-700 "
    :class="[
      'hover:text-primary-700 dark:hover:text-primary-600',
      headerStore.selectedButton === index ? 'text-primary-700 dark:text-primary-600' : 'text-gray-700'
    ]"
    @click="toggleMenu(button.menu, index)"
  >
    <div>
      {{button.label}}
    </div>
    <div v-if="button.type === 'Menu'" class="ml-2">
      <font-awesome-icon v-if="headerStore.selectedMenu === button.menu" icon="fa-regular fa-chevron-up" size="xs"/>
      <font-awesome-icon v-else icon="fa-regular fa-chevron-down" size="xs"/>
    </div>
  </div> -->
  <a v-if="button.type === 'Menu'" class="menu-btn flex justify-between gap-4 md:gap-2 py-3 px-4 md:p-0 items-center" @click="toggleMenu(button.menu, index)">
    <div class="font-semibold text-base text-gray-900">{{button.label}}</div>
    <div class="dropdown-icon">
      <!-- <font-awesome-icon v-if="headerStore.selectedMenu === button.menu" icon="fa-regular fa-chevron-up" size="xs"/>
      <font-awesome-icon v-else icon="fa-regular fa-chevron-down" size="xs"/> -->
      <div :class="headerStore.selectedMenu === button.menu && headerStore.showMenu ? 'selected' : 'inactive'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 7.5L10 12.5L15 7.5" :stroke="headerStore.selectedMenu === button.menu && headerStore.showMenu ? '#101828' : '#667085'" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </a>
  <a v-else :href="button.type === 'Link' ? button.link : '#'"  class="menu-btn flex justify-between gap-4 md:gap-2 py-3 px-4 md:p-0 items-center">
    <div class="font-semibold text-base text-gray-900">{{button.label}}</div>
  </a>
</template>

<script setup>
import { useHeaderStore } from '@/stores'

const headerStore = useHeaderStore()

const props = defineProps(['button', 'index'])

function toggleMenu (menu, id) {
    headerStore.showMenu = false
  if (headerStore.selectedMenu === menu) {
    headerStore.showMenu = false
    headerStore.selectedMenu = null
    headerStore.selectedButton = id
  } else {
    headerStore.selectedMenu = menu
    headerStore.selectedButton = id
    headerStore.showMenu = true
  }
  if (headerStore.selectedMenu == null) {
    headerStore.showMenu = false
  }
}
</script>
